import React from 'react';
import {AbsoluteFill} from 'remotion';

// Test of Devanagari script and emojis,
export const Scripts: React.FC = () => {
	return (
		<AbsoluteFill
			style={{
				backgroundColor: 'white',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<h1>पूर्वोत्तर में बीजेपी का मजबूत चेहरा 😁</h1>
		</AbsoluteFill>
	);
};
